import moment from 'moment';

export const COLUMNS = [
  {
    Header: "Created On",
    accessor: "createdTime",

    Cell: ({ value }) => {
      return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
    }
  },
  {
    Header: "Filed On",
    accessor: "requestTime",

    Cell: ({ value }) => {
      if (value) {
        return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
      } else {
        return "";
      }
    },
  },
  // {
  //   Header: "Filed Reason",
  //   accessor: "fileReason",
  // },

  {
    Header: "Type",
    accessor: "documentType",
  },

  {
    Header: "Msg Text",
    accessor: "messagetext",
  },
  {
    Header: "Action Type",
    accessor: "action",
  },
];

export const COLUMN_CBSA = [
  {
    Header: "Created On",
    accessor: "createdTime",
    Cell: ({ value }) => {
      return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
    },
  },
  {
    Header: "Filed On",
    accessor: "requestTime",

    Cell: ({ value }) => {
      if (value) {
        return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
      } else {
        return "";
      }
    },
  },
  // {
  //   Header: "Filed Reason",
  //   accessor: "fileReason",
  // },
  {
    Header: "Form Type",
    accessor: "formType",
  },
  {
    Header: "Msg Text",
    accessor: "messagetext",
  },
  {
    Header: "EDI Format",
    accessor: "ediFormat",
  },
  {
    Header: "Action Type",
    accessor: "action",
  },
];

export const COLUMN_CARM = [
  {
    Header: "Created On",
    accessor: "createdDate",
    Cell: ({ value }) => {
      console.log("value:", value);
      return moment(new Date(value["epochs"])).format("MM-DD-YY hh:mm:ss") 
    },
  },
  
  {
    Header: "Status",
    accessor: "status",
  },
];



export const COLUMN_C88 = [
  {
    Header: "Created On",
    accessor: "createdTime",

    Cell: ({ value }) => {
      return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
    },
  },
  {
    Header: "Filed On",
    accessor: "requestTime",
    Cell: ({ value }) => {
      if (value) {
        return moment(new Date(value)).format("MM-DD-YY hh:mm:ss") 
      } else {
        return "";
      }
    },
  },
  // {
  //   Header: "Filed Reason",
  //   accessor: "fileReason",
  // },
  {
    Header: "Type",
    accessor: "documentType",
  },
  {
    Header: "Msg Text",
    accessor: "messagetext",
  },
  {
    Header: "Csp Type",
    accessor: "cspType",
  },
  {
    Header: "Request Type",
    accessor: "requestType",
  },
];
